import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

import type { Prefixes as PickerPrefixes } from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/LargePicker/LargePicker.types'
import { getOptionIcon } from '~/scopes/product-core/components/presentationals/CustomizationFunnel/utils/getOptionIcon'

import { CLICKABLE_STEP_GUIDANCE_MODAL } from '../CustomizationFunnel.constants'

import type { Option, Step } from './types'

export const mapOption = (
  {
    sublabel = undefined,
    ...option
  }: GetPickersResponse['pickerGroups'][number]['items'][number],
  pickerPrefix: PickerPrefixes = 'circle',
): Option => {
  return {
    ...option,
    subLabel: sublabel ?? undefined,
    style: {
      prefix: pickerPrefix,
    },
  }
}

export const mapStep = (
  group: GetPickersResponse['pickerGroups'][number],
): Step => {
  return {
    id: group.id,
    title: group.sectionTitle ?? group.label,
    titleEmphasis: null,
    trackingId: group.trackingId,
    options:
      group.items.map((option) =>
        mapOption(option, getOptionIcon(group, option)),
      ) ?? [],
    desktopIllustration: undefined,
    columns: 2,
    guidance:
      group.guidanceCard && CLICKABLE_STEP_GUIDANCE_MODAL[group.id]
        ? {
            modalName: CLICKABLE_STEP_GUIDANCE_MODAL[group.id],
            ...(group.guidanceCard.icon?.name
              ? { icon: group.guidanceCard.icon.name }
              : {}),
            ...(group.guidanceCard.icon?.url
              ? { image: group.guidanceCard.icon.url }
              : {}),
            label: group.guidanceCard.text,
            clickable: group.guidanceCard.clickable || false,
          }
        : undefined,
    sideContentV2: group.sideContentV2,
  }
}
